import React from "react";
import { Empty, Button, Card } from "antd";

import "./superUserPlanTableSelectable.scss";

export default function NuJobsPlanCards({
  data
}) {

  if (!data || data.length === 0) {
    return <Empty style={{ margin: "60px" }} />;
  }

  const planFeatures = {
    Free: [
      "Job Search",
      "Apply For Jobs",
      "Save Jobs",
      "Hide/Show Profile",
      "Ads"
    ],

    Monthly: [
      "Everything in Free",
      "7 days Trial",
      "Premium Job Recommendations",
      "Store Multiple Resumes",
      "Apply to Multiple Jobs Simultaneously",
      "Auto Application to Matching Jobs" ,
      "No Ads"  
    ],

    Quarterly: [
      "Everything in Monthly",
      "7 days Trial",
      "Access to Skill Practice and Evaluation Platform",
    ],
  };  
  const planNotes = {
  Quarterly:
    "Our goal is to help you find your next opportunity within 3 months. That's why we don't offer longer plans.",
  };
  const handleNewSubscription = (planname) =>{
     if(planname == "Free"){

     }else if (planname == "Monthly"){

     }else if (planname == "Quarterly"){

     }
  }
  return (
    <div className="nujobs-plan-cards-wrapper">

      <div className="nujobs-plan-cards">
        {data.map((plan) => {

          let price = 0;
          let period = "year";
          const features = planFeatures[plan.planname] || [];
          if (plan.monthly > 0) {
            price = plan.monthly;
            period = "month";
          } else if (plan.quarterly > 0) {
            price = plan.quarterly;
            period = "quarter";
          } else if (plan.hyearly > 0) {
            price = plan.hyearly;
            period = "6 months";
          } else if (plan.yearly > 0) {
            price = plan.yearly;
            period = "year";
          }

          return (
            <Card
              key={plan.planname}
              className={`nujobs-plan-card nujobs-plan-${plan.planname.toLowerCase()}`}
              hoverable
            >

              <div className="nujobs-plan-name">
                {plan.planname}
              </div>

              <div className="nujobs-plan-price">
                {price === 20000 ? (
                  <span className="nujobs-plan-free">
                    Free
                  </span>
                ) : (
                  <>
                    <span className="nujobs-plan-currency">
                      ₹
                    </span>

                    <span className="nujobs-plan-price-value">
                      {price}
                    </span>

                    <span className="nujobs-plan-price-period">
                      / {period}
                    </span>
                  </>
                )}
              </div>

              <div className="nujobs-plan-divider" />

              <div className="nujobs-plan-features">

                {features.map((feature, featureIndex) => (
                  <div
                    className="nujobs-plan-feature"
                    key={featureIndex}
                  >
                    <span className="nujobs-plan-check">
                      ✓
                    </span>

                    <span>
                      {feature}
                    </span>
                  </div>
                ))}

              </div>

              <div className="nujobs-plan-button">
                <Button
                  type={
                    plan.planname !== "Free"
                      ? "primary"
                      : "default"
                  }
                  block
                  size="large"
                  onClick={handleNewSubscription}
                >
                  {plan.planname === "Free"
                    ? "Current Plan"
                    : "Subscribe Now"}
                </Button>
              </div>
            </Card>
          );
        })}
      </div>

    </div>
  );
}

